/**
 * @module core/aem
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProductDetails } from '@experience/shop/product-details/interfaces/product-details.interface';
import { Features } from '@support/api/common/product.interface';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { ProductDetailsService } from '@experience/shop/services/product-details.service';
import { Subject } from 'rxjs';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { HARDGOODS_CONSTANTS } from '@experience/shop/hardgoods/constants/browse-hardgoods.constants';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'tmo-product-features',
  templateUrl: './product-features.component.html',
  styleUrls: [],
})
export class ProductFeaturesComponent implements OnInit, OnDestroy {
  /**
   * Stores device details coming from API call
   */
  public deviceDetails: ProductDetails;
  /**
   * Stores the list of features
   */
  public features: Features[];
  /**
   * Stores content coming from AEM call
   */
  public pdpStaticContent: ConfigData;

  /**
   * Stores the hardgood constants
   */
  public financial: string;
  /**
   * to distroy the event OnDestroy life cycle
   */
  private ngUnsubscribe: Subject<void>;

  constructor(
    private productDetailsService: ProductDetailsService,
    private stateStoreUtils: StateStoreUtilsService
  ) {
    this.ngUnsubscribe = new Subject<void>();
  }
  /**
   * loads the initial state of product Features component
   * @returns void
   */
  public ngOnInit(): void {
    this.financial = HARDGOODS_CONSTANTS.FINANCIAL;
    this.productDetailsService
      .getProductDetailsContent()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((content: ConfigData) => {
        this.pdpStaticContent = content;
        const offerId = this.stateStoreUtils.getSelectedOfferId();
        const product = this.stateStoreUtils.getSelectedDeviceDetails(offerId);
        this.deviceDetails = product.getProductDetails();
        this.features = [];
        if (this.deviceDetails) {
          this.features = product.getProductFeatures();
        }
      });
  }

  /**
   * Component lifecycle hook to destroy the component
   * @returns void
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
